import { render, staticRenderFns } from "./TabellaOrdini.vue?vue&type=template&id=020f9371&scoped=true&"
import script from "./TabellaOrdini.vue?vue&type=script&lang=js&"
export * from "./TabellaOrdini.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020f9371",
  null
  
)

export default component.exports